import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class CompassWorkshopSteps extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.

  static modelName = 'CompassWorkshopSteps'
  // Define default properties here
  static instanceDefaults () {
    return {
      parentCompassWorkshopStepId: null,
      title: '',
    }
  }
}
const servicePath = 'compass-workshop-steps'
const servicePlugin = makeServicePlugin({
  Model: CompassWorkshopSteps,
  service: feathersClient.service(servicePath),
  servicePath,
  state: {
    isSaving: false,
  },
  mutations: {
    setIsSaving (state, value) {
      state.isSaving = value
    },
  },
  getters: {
    isSaving: state => state.isSaving,
  },
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
})

export default servicePlugin
